import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { ConfigurationShelfSampleTypeAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-shelf-sample-type-assignment/configuration-shelf-sample-type-assignment.dto'
import { ConfigurationSampleTypeResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-sample-type/configuration-sample-type.dto'
import { configurationSampleTypeService } from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-sample-type/configuration-sample-type.service'
import { CommonVirtualShelfEnumResponse } from '@/api/services/common/virtual-shelf/common-virtual-shelf.dto'
import { commonVirtualShelfService } from '@/api/services/common/virtual-shelf/common-virtual-shelf.service'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

@Component
export default class ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly shelfSampleTypeAssignment!: Partial<ConfigurationShelfSampleTypeAssignmentResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.shelfSampleTypeAssignment?.id
    }

    constructor() {
        super()

        this.$validator = this.externalValidator
    }

    async getSampleTypes(): Promise<ConfigurationSampleTypeResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationSampleTypeService.paginator(undefined, params))
        if (response) {
            return response.content
        }
        return []
    }

    async getVirtualShelfs(): Promise<CommonVirtualShelfEnumResponse[]> {
        const response = await this.$_toCallUnique(commonVirtualShelfService.getVirtualShelfs())
        if (response) {
            return response
        }
        return []
    }
}
